<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q2b0PU/tc-custom/9781504062978.jpg?1696813820088" alt="This image is the cover for the book Julius Caesar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Julius Caesar
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Shakespeare’s tragic tale of power, politics, friendship, and betrayal in ancient Rome.</b></p><p>Julius Caesar is basking in the glow of military triumph—but his friend Brutus has fallen in with a band of conspirators who argue that Caesar’s ambitions may soon cast a pall of tyranny over Rome’s people. Torn, Brutus finally agrees to pick up a knife and join in assassinating Caesar on the Ides of March.</p> His act is driven by a fear of dictatorship and a desire to protect the citizenry, but the events that follow will have heart-wrenching consequences, in one of the immortal playwright William Shakepeare’s greatest works.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Shakespeare
      </h2>
      
      <p class="authorDescription body article">William Shakespeare was an English poet, playwright, and actor. He is widely regarded as the greatest dramatist in the English language. Shakespeare is often called England&rsquo;s national poet and the &ldquo;Bard of Avon.&rdquo;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23152e21